module.exports = "/_next/static/images/arrow_green-0bdc08317b8e43f0a104e06a44fc0458.svg";